import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';

export default class StepLayout extends Component {
  static propTypes = {
    children: PropTypes.shape({
      Progress: PropTypes.node.isRequired,
      SideBar: PropTypes.node.isRequired,
      Form: PropTypes.node.isRequired,
    }),
  };

  render() {
    const { Progress, SideBar, Form } = this.props.children;

    return (
      <div className="onboarding-wrapper">
        <Grid>
          <Row around="xs" className="progress-bar">
            <Col xs={12} md={10}>
              {Progress}
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row between="xs">
            <Col xs={12} md={8}>
              {Form}
            </Col>
            <Col xs={12} md={4}>
              {SideBar}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepLayout.js